// quarantine-state.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuarantineStateService {
  private isQuarantineDrugAlreadyResolvedSubject = new BehaviorSubject<boolean>(false);

  isQuarantineDrugAlreadyResolved$ = this.isQuarantineDrugAlreadyResolvedSubject.asObservable();

  updateQuarantineStatus(status: boolean) {
    this.isQuarantineDrugAlreadyResolvedSubject.next(status);
  }

  getCurrentStatus(): boolean {
    return this.isQuarantineDrugAlreadyResolvedSubject.value;
  }
}
